module.exports = __webpack_public_path__ + "media/images/pic/hero/stats-wave-ba97fbf5e18abf0f1a211d7da517e107.png";